import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { Card } from './SubscriptionAppCard';
import { getUpcomingBillingCount, toIsoDate } from '../data/mockUpcomingBillings';
const DAYS_SHOWN = 7;
export function UpcomingBillingsStrip() {
  const navigate = useNavigate();
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = Array.from({
    length: DAYS_SHOWN
  }, (_, offset) => {
    const date = new Date(today);
    date.setDate(today.getDate() + offset);
    return date;
  });
  return <Card padding="none" className="mb-8" data-id="element-6337" data-mp="1cthoz09gq020">
      <div className="p-6 border-b border-[#E2E8F0] flex justify-between items-center bg-white rounded-t-lg" data-id="element-6338" data-mp="17zdfoacq5fxr">
        <div className="flex items-center gap-2" data-id="element-6339" data-mp="130kcbar5j5bb">
          <Calendar className="w-5 h-5 text-[#0EA5E9]" data-id="element-6340" data-mp="20gpu9i6w5941" />
          <h3 className="text-sm font-semibold text-[#0F172A]" data-id="element-6341" data-mp="20ialaxtzy9x5">Next 7 days</h3>
        </div>
        <button type="button" onClick={() => navigate('/subscriptions', {
        state: {
          subscriptionsView: 'calendar'
        }
      })} className="text-[13px] text-[#0EA5E9] font-medium hover:text-[#0284C7] flex items-center gap-1 transition-colors" data-id="element-6342" data-mp="1vp7sirx1n4i0">
          View calendar <ArrowRight className="w-4 h-4" data-id="element-6343" data-mp="229a12kdt6vx7" />
        </button>
      </div>

      <div className="p-6 bg-white rounded-b-lg" data-id="element-6344" data-mp="2794t4r9blrju">
        <div className="grid grid-cols-7 gap-3" data-id="element-6345" data-mp="277toyqbyqhs7">
          {days.map((date, index) => {
          const isToday = index === 0;
          const isoDate = toIsoDate(date);
          const count = getUpcomingBillingCount(date);
          const dayLabel = isToday ? 'Today' : date.toLocaleDateString('en-AU', {
            weekday: 'short'
          });
          const dateLabel = date.toLocaleDateString('en-AU', {
            day: 'numeric',
            month: 'short'
          });
          return <button key={isoDate} type="button" onClick={() => navigate('/subscriptions', {
            state: {
              subscriptionsView: 'calendar',
              focusDate: isoDate
            }
          })} aria-label={`${isToday ? 'Today' : dayLabel}, ${dateLabel}: ${count} subscriptions due`} className={`flex flex-col items-center text-center rounded-lg border px-2 py-4 transition-colors hover:bg-[#F8FAFC] ${isToday ? 'border-[#7DD3FC] bg-[#F0F9FF]' : 'border-[#E2E8F0] bg-white'}`} data-id="element-6346" data-mp="3dqrvgt9i2j72" data-mpi={index}>
                <span className="text-[11px] font-semibold uppercase tracking-wider text-[#94A3B8]" data-id="element-6347" data-mp="32boj819wrfjn">
                  {dayLabel}
                </span>
                <span className="text-xs text-[#64748B] mt-0.5" data-id="element-6348" data-mp="3uz2msi8439cq">{dateLabel}</span>
                <span className={`text-2xl mt-2 ${count === 0 ? 'font-medium text-[#CBD5E1]' : 'font-bold text-[#0F172A]'}`} data-id="element-6349" data-mp="3q82op9n9al8n">
                  {count}
                </span>
                <span className="text-xs text-[#94A3B8]" data-id="element-6350" data-mp="3l8psvzeeq3tx">due</span>
              </button>;
        })}
        </div>
      </div>
    </Card>;
}